export const POST_ITEMVERIFICATION_REQUEST = "POST_ITEMVERIFICATION_REQUEST";
export const POST_ITEMVERIFICATION_SUCCESS = "POST_ITEMVERIFICATION_SUCCESS";
export const POST_ITEMVERIFICATION_FAIL = "POST_ITEMVERIFICATION_FAIL";

export const POST_BULKORDER_REQUEST = "POST_BULKORDER_REQUEST";
export const POST_BULKORDER_SUCCESS = "POST_BULKORDER_SUCCESS";
export const POST_BULKORDER_FAIL = "POST_BULKORDER_FAIL";
